import { getPlayer, getTeam } from "../../utils.js";
import GameFactEventDto from "../GameFactEventDto.js";

export class ReplacementDto extends GameFactEventDto {

    constructor(event){
        super(event);
        this.tab = event.tab ??"REMPLACEMENT"
        this.detail = {
            ...this.detail,
            title : event.detail?.title || "REMPLACEMENT",
            inplayer: event.detail?.inplayer,
            outplayer: event.detail?.outplayer,
            reason: event.detail?.reason,
          };
    }

    get inplayer() {
        return this.detail.inplayer;
    }
    set inplayer(value) {
        this.detail.inplayer = value;
    }

    get outplayer() {
        return this.detail.outplayer;
    }
    set outplayer(value) {
        this.detail.outplayer = value;
    }

    get reason() {
        return this.detail.reason;
    }
    set reason(value) {
        this.detail.reason = value;
    }

    initTimerPeriod(match){
        super.initTimerPeriod(match)
    }

    updateDetail(key, value, match) {
        console.log('ReplacementDto.updateDetail called with key=', key, ' value=', value)
        super.updateDetail(key, value)

        console.log('ReplacementDto.updateDetail key=', key, ' value=', value)
        
        // On peut modifier le text et le title
        if(this.isAutomaticCommentary && ["isAutomaticCommentary", "team", "inplayer", "outplayer", "reason"].includes(key)){
            let commentaire = "Remplacement"

            const inPlayer = getPlayer(this.inplayer, match)
            const outPlayer = getPlayer(this.outplayer, match)
            const team = getTeam(this.team, match)

            if(this.inplayer){
                if(inPlayer){
                    commentaire += ' de '+ outPlayer.lastname
                }

                if(this.outplayer){
                    if(outPlayer){
                        commentaire += ' par '+ inPlayer.lastname
                    }
                }
            }else if(team){
                commentaire += ' pour '+ team.name
            }

            commentaire += "."

            console.log('reason dans ReplacementDto.updateDetail=', this.reason)

            if(this.reason){
                switch(this.reason){
                    case 'blessure':
                        commentaire+=' Raison : Blessure.'
                    break
                    case 'tactique':
                        commentaire+=' Raison : Tactique.'
                    break
                    case 'cartonorange':
                        commentaire+=' Raison : Carton orange.'
                    break
                }
            }

            this.text = commentaire
        }
    }
}